import { render } from "./Ma10drTrend.vue?vue&type=template&id=a8d75fc0&scoped=true"
import script from "./Ma10drTrend.vue?vue&type=script&lang=js"
export * from "./Ma10drTrend.vue?vue&type=script&lang=js"

import "./Ma10drTrend.vue?vue&type=style&index=0&id=a8d75fc0&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d75fc0"]])

export default __exports__